function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { Button, Popper } from '@deephaven/components';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export default class RenameDialog extends PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "renameInputRef", void 0);
    this.handleRenameDialogOpened = this.handleRenameDialogOpened.bind(this);
    this.handleRenameInputChange = this.handleRenameInputChange.bind(this);
    this.handleRenameCancel = this.handleRenameCancel.bind(this);
    this.handleRenameSubmit = this.handleRenameSubmit.bind(this);
    this.renameInputRef = /*#__PURE__*/React.createRef();
    var value = props.value;
    this.state = {
      value,
      valueWasValidated: false
    };
  }
  componentDidUpdate(prevProps) {
    var prevIsShown = prevProps.isShown;
    var isShown = this.props.isShown;
    // Reset the state on dialog shown and not on the `value` prop change
    // so the input keeps the internal value while the dialog is open.
    // Useful in case the `value` prop update is triggered externally
    // i.e. by someone else renaming the same shared dashboard
    if (isShown && !prevIsShown) {
      this.resetState();
    }
  }
  resetState() {
    var value = this.props.value;
    this.setState({
      value,
      valueWasValidated: false
    });
  }
  handleRenameDialogOpened() {
    var _this$renameInputRef;
    (_this$renameInputRef = this.renameInputRef) === null || _this$renameInputRef === void 0 || (_this$renameInputRef = _this$renameInputRef.current) === null || _this$renameInputRef === void 0 || _this$renameInputRef.focus();
  }
  handleRenameInputChange(event) {
    this.setState({
      value: event.target.value
    });
  }
  handleRenameCancel() {
    var onCancel = this.props.onCancel;
    onCancel();
  }
  handleRenameSubmit(event) {
    event.stopPropagation();
    event.preventDefault();
    var value = this.state.value;
    var newTitle = value === null || value === void 0 ? void 0 : value.trim();
    if (newTitle !== undefined && newTitle !== '') {
      var onSubmit = this.props.onSubmit;
      onSubmit(newTitle);
    } else {
      this.setState({
        value: newTitle,
        valueWasValidated: true
      });
    }
  }
  renderRenameDialog() {
    var _this$props = this.props,
      isShared = _this$props.isShared,
      isOwner = _this$props.isOwner,
      itemType = _this$props.itemType;
    var _this$state = this.state,
      value = _this$state.value,
      valueWasValidated = _this$state.valueWasValidated;
    return /*#__PURE__*/_jsxs("form", {
      className: classNames('p-3', {
        'was-validated': valueWasValidated
      }),
      onSubmit: this.handleRenameSubmit,
      noValidate: true,
      role: "presentation",
      onMouseDown: event => {
        // block events in the NewTabScreen ItemList
        event.stopPropagation();
      },
      onMouseUp: event => {
        event.stopPropagation();
      },
      children: [/*#__PURE__*/_jsxs("div", {
        className: "form-group",
        children: [/*#__PURE__*/_jsxs("label", {
          htmlFor: "rename-dialog-".concat(itemType, "-input"),
          children: ["Rename ", itemType]
        }), /*#__PURE__*/_jsx("input", {
          type: "text",
          className: "form-control",
          id: "rename-dialog-".concat(itemType, "-input"),
          value: value !== null && value !== void 0 ? value : undefined,
          ref: this.renameInputRef,
          onChange: this.handleRenameInputChange,
          required: true
        }), /*#__PURE__*/_jsxs("div", {
          className: "invalid-feedback",
          children: [itemType, " name cannot be empty"]
        }), (isShared || !isOwner) && /*#__PURE__*/_jsxs("div", {
          className: "pt-2",
          children: ["Renaming this ", itemType, " will rename for all users."]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "text-right",
        children: [/*#__PURE__*/_jsx(Button, {
          kind: "secondary",
          className: "mr-2",
          onClick: this.handleRenameCancel,
          children: "Cancel"
        }), /*#__PURE__*/_jsx(Button, {
          kind: "primary",
          type: "submit",
          children: "Rename"
        })]
      })]
    });
  }
  render() {
    var _this$props2 = this.props,
      isShown = _this$props2.isShown,
      onCancel = _this$props2.onCancel;
    return /*#__PURE__*/_jsx(Popper, {
      isShown: isShown,
      onEntered: this.handleRenameDialogOpened,
      onExited: onCancel,
      options: {
        placement: 'bottom'
      },
      interactive: true,
      closeOnBlur: true,
      children: this.renderRenameDialog()
    });
  }
}
_defineProperty(RenameDialog, "defaultProps", {
  isShared: false,
  isOwner: true,
  itemType: 'Item',
  value: ''
});
//# sourceMappingURL=RenameDialog.js.map